import React, { ReactElement, SVGProps } from 'react'
import BaseIcon from "./BaseIcon";

export default function DoubleThinArrowIcon(props: SVGProps<any>): ReactElement {
  return (
    <BaseIcon {...props}>
      <path
        d="m10.5 16.5-3 3-3-3m3-12v15m6-12 3-3 3 3m-3 12v-15"
        stroke="currentColor"
        strokeWidth="1.125"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </BaseIcon>
  )
}
